import styled, { css } from 'foundations-theming-specialty/utils';
export const GlobalToolbarDivider = styled.div.withConfig({
  displayName: "GlobalToolbarDivider",
  componentId: "k9a7ax-0"
})(({
  theme
}) => {
  return css(["height:24px;width:1px;background:", ";content:'';margin:0 5px 0 11px !important;"], theme.color['global-shell-border-default']);
});